import useDevice from "../hooks/useDevice";
import Button, { ButtonProps } from "./Button";
import Text from "./Text";
import IcoSearch from "../../assets/img/Ico_search_white.png";
import IcoPlus from "../../assets/img/Ico_plus_orange.png";
import Flex from "./Flex";

type ButtonType = 'search' | 'regist' | 'save' | 'reset' | 'default'

type ManageButtonProps = Omit<ButtonProps, "role"> & {
    btnType: ButtonType;
    text?: string;
    color?: string;
}

const ManageButton = ({
    btnType,
    text,
    color,
    ...props
}: ManageButtonProps) => {
    const device = useDevice();
    const isMobile = device !== 'desktop'

    switch (btnType) {
        case 'search':
            return (
                <Button
                    width={75}
                    height={isMobile ? 41 : 34}
                    paddingX={18}
                    paddingY={9}
                    borderRadius={8}
                    icon={<img src={IcoSearch} style={{width: "14px", height: "14px"}} alt="search" />}
                    {...props}
                >
                    <Text variant="span" size={14} color="white" weight={"semibold"}>검색</Text>
                </Button>
            );
        case 'regist':
            return (
                <Button
                    variant="regist"
                    width={75}
                    height={isMobile ? 41 : 34}
                    paddingX={18}
                    paddingY={9}
                    border={1}
                    borderRadius={8}
                    icon={<img src={IcoPlus} style={{width: "10px", height: "10px"}} alt="plus" />}
                    {...props}
                >
                    <Text variant="span" size={14} color="rgba(238, 125, 0, 1)" weight={"semibold"}>등록</Text>
                </Button>
            );
        case 'save':
            return (
                <Button
                    width={75}
                    height={isMobile ? 41 : 34}
                    paddingX={18}
                    paddingY={9}
                    borderRadius={8}
                    {...props}
                >
                    <Text size={14}>저장</Text>
                </Button>
            );
        case 'reset':
            return (
                <Button
                    width={75}
                    height={isMobile ? 41 : 34}
                    paddingX={18}
                    paddingY={9}
                    borderRadius={8}
                    {...props}
                >
                    <Text size={14}>초기화</Text>
                </Button>
            );
        default:
            return (
                <Button
                    width={75}
                    height={isMobile ? 41 : 34}
                    paddingX={18}
                    paddingY={9}
                    borderRadius={8}
                    {...props}
                >
                    <Text size={14} color={color}>{text}</Text>
                </Button>
            );
    }
}

export default ManageButton;